<template>
    <div class="main-content">
        <the-header :title="title"/>
        <nav-body ref="nav" :openFirst="$route.name === 'content'" :links="nav" v-on:changeTitle="title = $event">
            <change-password v-if="$route.params.type === 'change-password'"/>
            <update-profile v-if="$route.params.type === 'update'"/>
            <notifications v-if="$route.params.type === 'notifications'"/>
        </nav-body>
    </div>
</template>

<script>
    import TheHeader from '../../../admin/Layout/TheHeader'
    import NavBody from '../../../admin/Layout/NavBody'
    import StaticText from '../../../admin/Pages/StaticText/StaticText'
    import ChangePassword from "./components/ChangePassword"
    import UpdateProfile from "./components/UpdateProfile"
    import Notifications from "./components/Notifications"

    export default {
        components: {
            Notifications,
            UpdateProfile,
            ChangePassword,
            StaticText,
            NavBody,
            TheHeader
        },
        mounted() {

        },
        methods: {

        },
        data() {
            return {
                title: this.t('Profile'),
                nav: [
                    {
                        name: this.t('Change password'),
                        route: {name: 'profile', params: {type: 'change-password'}},
                        listHeaderButtons: [],
                    }, {
                        name: this.t('Update profile'),
                        route: {name: 'profile', params: {type: 'update'}},
                        listHeaderButtons: [],
                    }, {
                        name: this.t('Notifications'),
                        route: {name: 'profile', params: {type: 'notifications'}},
                        listHeaderButtons: [],
                    }
                ]
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/private/profile/Profile.vue